import React, { useEffect, useRef, useState } from "react";
import {
  Plus,
  Minus,
  ShoppingBag,
  Heart,
  Share2,
  ZoomIn,
  Loader2,
} from "lucide-react";
import { set } from "lodash";
import { NoBackpackSharp } from "@mui/icons-material";
// 1. SPOSTATO FUORI (Definizione stabile)
// Funzione helper aggiornata per gestire query string (es. ?t=123)
const getFallbackExtension = (url) => {
  if (!url) return null;

  // LOGICA REGEX:
  // \.png       -> Cerca la stringa ".png"
  // (?=\?|$)    -> "Lookahead": verifica che dopo ci sia un "?" OPPURE la fine della stringa ($)
  // flag 'i'    -> Case insensitive (PNG, png, Png)

  // 1. Se è PNG, diventa JPG
  if (/\.png(?=\?|$)/i.test(url)) {
    return url.replace(/\.png(?=\?|$)/i, '.jpg');
  }

  // 2. Se è JPG/JPEG, diventa PNG
  if (/\.jpe?g(?=\?|$)/i.test(url)) {
    return url.replace(/\.jpe?g(?=\?|$)/i, '.png');
  }

  return null; // Nessuna estensione gestita trovata
};

const ImageWithLoader = ({
  src,
  alt,
  className,
  style,
  width,
  height,
  isSingleVariant,
  ...props
}) => {
  const [isLoading, setIsLoading] = useState(true);

  // Stato per gestire l'URL corrente (può cambiare se facciamo fallback)
  const [currentSrc, setCurrentSrc] = useState(src);

  // Stato per sapere se abbiamo già tentato il cambio estensione
  const [hasTriedFallback, setHasTriedFallback] = useState(false);

  const imgRef = useRef(null);

  // 1. RESET INIZIALE
  // Se la prop `src` cambia dall'esterno, resettiamo tutto
  useEffect(() => {
    setCurrentSrc(src);
    setHasTriedFallback(false);
    setIsLoading(true);
  }, [src]);

  // 2. CONTROLLO CACHE
  // Controlliamo se l'immagine (currentSrc) è già completa
  useEffect(() => {
    if (imgRef.current && imgRef.current.complete) {
      // Verifica opzionale: assicurarsi che naturalWidth sia > 0 per considerarla valida
      if (imgRef.current.naturalWidth > 0) {
        setIsLoading(false);
      }
    }
  }, [currentSrc]); // Esegui quando cambia currentSrc

  // 3. GESTORE ERRORI (Logica png <-> jpg)
  const handleError = () => {
    // Se abbiamo già provato il fallback e fallisce ancora, ci arrendiamo
    if (hasTriedFallback) {
      setIsLoading(false);
      return;
    }

    const fallbackUrl = getFallbackExtension(currentSrc);

    if (fallbackUrl) {
      // Proviamo la nuova estensione
      console.log(`Immagine non trovata: ${currentSrc}. Tento con: ${fallbackUrl}`);
      setHasTriedFallback(true);
      setCurrentSrc(fallbackUrl);
      // Non mettiamo isLoading(false) perché stiamo ancora aspettando la nuova immagine
    } else {
      // Non è un'estensione gestita, stop caricamento
      setIsLoading(false);
    }
  };


  return (
    <div
      className="position-relative d-flex align-items-center justify-content-center w-100"
      style={{ minHeight: height ? "auto" : "200px" }}
    >
      {/* LOADER SPINNER */}
      {isLoading && !isSingleVariant && (
        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center z-1 bg-light rounded">
          <div
            className="spinner-border text-primary"
            role="status"
            style={{ width: "2rem", height: "2rem" }}
          >
            <span className="visually-hidden">Caricamento...</span>
          </div>
        </div>
      )}

      {/* IMMAGINE */}
      {!isSingleVariant && (
        <img
          ref={imgRef}
          src={currentSrc} // Usiamo lo stato interno, non la prop diretta
          alt={alt}
          width={width}
          height={height}
          style={{ ...style, transition: "opacity 0.3s ease-in-out" }}
          className={`${className || ""} ${isLoading ? "opacity-0" : "opacity-100"}`}
          // intrinsicsize="350x150" // Attenzione: intrinsicsize è deprecato/non standard in molti browser moderni
          onLoad={() => setIsLoading(false)}
          onError={handleError} // Qui scatta la magia del fallback
          {...props}
        />
      )}
    </div>
  );
};
export default function ProductSplitView({
  description,
  measure,
  imageModel,
  product,
  template,
  ord,
  pagina,
  variantOffset,
  offsetPerPage,
  listini,
  setEditDialog,
  editDialog
}) {
  // Stato iniziale
  const [variants, setVariants] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  const [variantsMeasure, setVariantsMeasure] = useState("");
  /*const ImageWithLoader = ({
    src,
    alt,
    className,
    style,
    width,
    height,
    ...props
  }) => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
      setIsLoading(true);
    }, [src]);

    return (
      <div
        className="position-relative d-flex align-items-center justify-content-center w-100"
        style={{ minHeight: height ? "auto" : "200px" }}
      >
        {isLoading && !props.isSingleVariant && (
          <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center z-1 bg-light rounded">
            <div
              className="spinner-border text-primary"
              role="status"
              style={{ width: "2rem", height: "2rem" }}
            >
              <span className="visually-hidden">Caricamento...</span>
            </div>
          </div>
        )}

        {!props.isSingleVariant && (
          <img
            src={src}
            alt={alt}
            width={width}
            height={height}
            style={{ ...style, transition: "opacity 0.3s ease-in-out" }}
            className={`${className || ""} ${isLoading ? "opacity-0" : "opacity-100"
              }`}
            intrinsicsize="350x150"
            onLoad={() => setIsLoading(false)}
            onError={() => setIsLoading(false)}
            {...props}
          />
        )}
      </div>
    );
  };*/
  useEffect(() => {
    console.log("Edit Dialog changed:", editDialog);
    var qty = parseInt(editDialog.currentQty);
    var qtaBox = parseInt(editDialog.pzBox);
    var prezzoBox = editDialog.preBox;
    if (qty > 0) {
      if (qty < editDialog.min) { qty = editDialog.min; }
      else if ((qty % editDialog.conf) !== 0) { qty = Math.ceil(qty / editDialog.conf) * editDialog.conf; }
    }
    if (template === "grid_with_sizes") {
      setVariants((prevVariants) =>
        prevVariants.map((color) => ({
          ...color,
          sizes: color.sizes.map((item) =>
            item.IDArtSizeColor === editDialog.id
              ? {
                ...item, quantity: qty,
                priceSco: qtaBox > 0 && qty >= qtaBox && parseFloat(prezzoBox) > 0 ? prezzoBox : undefined
              }
              : item
          ),
        }))
      );
    }
    else {
      setVariants((prevVariants) =>
        prevVariants.map((item) =>
          item.IDArtSizeColor === editDialog.id
            ? {
              ...item, quantity: qty,
              priceSco: qtaBox > 0 && qty >= qtaBox && parseFloat(prezzoBox) > 0 ? prezzoBox : undefined
            }
            : item
        )
      );
    }
  }, [editDialog]);
  // Funzione "Colabrodo" per fermare qualsiasi evento
  const stopAllEvents = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Ferma anche l'evento nativo nel caso la libreria ascolti il DOM direttamente
    if (e.nativeEvent) {
      e.nativeEvent.stopImmediatePropagation();
      e.nativeEvent.stopPropagation();
    }
  };
  useEffect(() => {
    let initialVariants = [];
    var m = "";
    // Controllo di sicurezza
    if (product && product.variation && product.variation.length > 0) {

      // --- LOGICA SPECIFICA PER GRID_WITH_SIZE (Struttura Nidificata) ---
      if (template === "grid_with_sizes") {

        const groupedVariants = product.variation.map((v, indexColor) => {
          return {
            // Dati del Colore padre
            colorId: `c-${indexColor}`, // ID fittizio per il gruppo colore
            color: v.color || `Variante ${indexColor + 1}`,

            // Array delle taglie per questo colore
            sizes: (v.size && v.size.length > 0) ? v.size.map((sizeItem, indexSize) => {
              return {
                // ID univoco indispensabile per gestire le quantità
                id: `${indexColor}-${indexSize}`,
                IDArtSizeColor: sizeItem.IDArtSizeColor,
                // Info specifiche della taglia
                sizeLabel: sizeItem.name || sizeItem.label || "Unica",

                quantity: 0, // Stato iniziale

                price: sizeItem["pricesco"] || sizeItem.pricesco || "0.00",
                src: global.baseUrlImage + sizeItem.nomImg, //+ "?t=" + Math.random(),
                nomImg: sizeItem.skuSizeColor,
                pzBox: listini.find(l => l.IDArt === sizeItem.IDArtSizeColor)?.pzBox || 1,
                pzMin: listini.find(l => l.IDArt === sizeItem.IDArtSizeColor)?.pzMin || 1,
                qtaConf: listini.find(l => l.IDArt === sizeItem.IDArtSizeColor)?.qtaConf || 1,
                preBox: listini.find(l => l.IDArt === sizeItem.IDArtSizeColor)?.preBox || "0.00",
              };
            }) : []
          };
        });

        // Impostiamo lo stato con la struttura nidificata
        // Nota: Qui solitamente non si applica lo slice (paginazione) 
        // perché in una tabella si mostrano tutte le varianti disponibili.
        setVariants(groupedVariants.slice(variantOffset, variantOffset + offsetPerPage));
        //console.log("Grouped Variants:", groupedVariants);
      }
      // --- LOGICA STANDARD (Struttura Piatta / Flat) ---
      else {
        // Usiamo flatMap per ottenere un unico array piatto
        initialVariants = product.variation.flatMap((v, indexColor) => {
          if (!v || !v.size || v.size.length === 0) return [];
          return v.size.map((sizeItem, indexSize) => {

            if (template === "photo_variant" && sizeItem.IDArtSizeColor != pagina.IDArtVariante) return null;
            m = (m || "") + " " + sizeItem.measure + ", ";
            return {
              id: `${indexColor}-${indexSize}`,
              IDArtSizeColor: sizeItem.IDArtSizeColor,
              color: v.colore || `Variante ${indexColor + 1}`,
              // sizeLabel opzionale nel flat view, ma utile averlo
              sizeLabel: sizeItem.taglia || sizeItem.label,
              quantity: 0,
              price: sizeItem["pricesco"] || sizeItem.pricesco || "0.00",
              src: global.baseUrlImage + sizeItem.nomImg,//+ "?t=" + Math.random(),
              nomImg: sizeItem.skuSizeColor,
              pzBox: listini.find(l => l.IDArt === sizeItem.IDArtSizeColor)?.pzBox || 1,
              pzMin: listini.find(l => l.IDArt === sizeItem.IDArtSizeColor)?.pzMin || 1,
              qtaConf: listini.find(l => l.IDArt === sizeItem.IDArtSizeColor)?.qtaConf || 1,
              preBox: listini.find(l => l.IDArt === sizeItem.IDArtSizeColor)?.preBox || "0.00",
            };
          });

        });
        m = m.slice(0, -2); // Rimuovi l'ultima virgola e spazio
        var measures = m.split(", ").slice(variantOffset, variantOffset + offsetPerPage).join(" // ");
        measures = measures.replaceAll("undefined // ", "");
        measures = measures.replaceAll("undefined", "");
        setVariantsMeasure(measures);
        if (template === "photo_variant") {
          setVariants(
            initialVariants.filter(v => v != null)
          );
        } else {
          setVariants(
            initialVariants.filter(v => v != null).slice(variantOffset, variantOffset + offsetPerPage)
          );
        }
      }
    }
  }, [product.variation, template, variantOffset, offsetPerPage]); // Aggiunto 'template' alle dipendenze

  const addVariant = () => {
    const newId = variants.length + 1;
    const isEven = newId % 2 === 0;
    setVariants([
      ...variants,
      {
        id: newId,
        color: isEven ? "beige" : "blue",
        quantity: 0,
        price: "49.00", // Default price per nuove varianti
        src: isEven
          ? "https://images.unsplash.com/photo-1591561954557-26941169b49e?auto=format&fit=crop&q=80&w=800"
          : "https://images.unsplash.com/photo-1575296093822-980ce4b1b0e7?auto=format&fit=crop&q=80&w=800",
      },
    ]);
  };

  const removeVariant = () => {
    if (variants.length > 0) {
      setVariants(variants.slice(0, -1));
    }
  };

  const updateQuantity = (e, id, delta, qtaMin, qtaConf, qtaBox, prezzoBox) => {
    e.stopPropagation(); // <--- AGGIUNGI QUESTA RIGA
    var minQta = qtaMin || 1;
    delta = delta * (qtaConf || 1);
    if (delta < 0) {
      minQta = 0;
    }
    if (template === "grid_with_sizes") {
      setVariants((prevVariants) =>
        prevVariants.map((color) => ({
          ...color,
          sizes: color.sizes.map((item) =>
            item.IDArtSizeColor === id
              ? {
                ...item, quantity: Math.max(minQta, item.quantity === qtaMin && delta < 0 ? 0 : item.quantity + delta),
                priceSco: qtaBox > 0 && Math.max(minQta, item.quantity === qtaMin && delta < 0 ? 0 : item.quantity + delta) >= qtaBox && parseFloat(prezzoBox) > 0 ? prezzoBox : undefined
              }
              : item
          ),
        }))
      );
    }
    else {
      setVariants((prevVariants) =>
        prevVariants.map((item) =>
          item.id === id
            ? {
              ...item, quantity: Math.max(minQta, item.quantity === qtaMin && delta < 0 ? 0 : item.quantity + delta),
              priceSco: qtaBox > 0 && Math.max(minQta, item.quantity === qtaMin && delta < 0 ? 0 : item.quantity + delta) >= qtaBox && parseFloat(prezzoBox) > 0 ? prezzoBox : undefined
            }
            : item
        )
      );
    }
  };

  const handleInputChange = (e, id, value) => {
    e.stopPropagation(); // <--- AGGIUNGI QUESTA RIGA
    const qty = parseInt(value);
    setVariants((prevVariants) =>
      prevVariants.map((item) =>
        item.id === id
          ? { ...item, quantity: isNaN(qty) ? 0 : Math.max(0, qty) }
          : item
      )
    );
  };

  const getGridClass = () => {
    const count = variants.length;
    if (template === "grid") {
      if (count <= 4) return "grid-quad";
      else return "grid-many";
    }
    if (template === "grid_with_sizes") {
      return "grid-quad";
    }
    if (count <= 1) return "grid-single";
    if (count === 2) return "grid-double";
    if (count <= 4) return "grid-quad";
    return "grid-many";
  };

  // Funzione helper per formattare il prezzo
  const formatPrice = (price) => {
    return Number(price).toLocaleString("it-IT", {
      style: "currency",
      currency: "EUR",
    });
  };
  const trovaPrezzoScontato = (variants, color) => {
    var filteredVariants = variants.filter(v => !color || v.color === color);
    if (filteredVariants.length > 0) {
      for (let i = 0; i < filteredVariants.length; i++) {
        if (filteredVariants[i].sizes.length > 0) {
          for (let j = 0; j < filteredVariants[i].sizes.length; j++) {
            if (filteredVariants[i].sizes[j].priceSco && parseFloat(filteredVariants[i].sizes[j].priceSco) > 0) {
              return filteredVariants[i].sizes[j].priceSco;
            }
          }
        }
      }
    }
  }
  const trovaPrezzo = (variants, color) => {
    var filteredVariants = variants.filter(v => !color || v.color === color);
    if (filteredVariants.length > 0) {
      for (let i = 0; i < filteredVariants.length; i++) {
        if (filteredVariants[i].sizes.length > 0) {
          for (let j = 0; j < filteredVariants[i].sizes.length; j++) {
            if (filteredVariants[i].sizes[j].price && parseFloat(filteredVariants[i].sizes[j].price) > 0) {
              return filteredVariants[i].sizes[j].price;
            }
          }
        }
      }
    }
  }
  return (
    <>
      <style>{`
        /* Reset e Base */
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body, html { height: 100%; background: #fff; }

        .app-container {
          display: flex;
          flex-direction: column;
          min-height: 75vh;
          height: 75vh !important;
          max-width: 1200px;
          min-width:100%;
          margin: 0 auto;
          background-color: white;
        }

        @media (max-width: 768px) {
          .app-container {
            max-width: 400px;
            margin: 20 auto;
          }
        }
        /* --- HEADER --- */
        .header {
          background-color: rgba(173, 208, 226, 1); 
          padding: 1.5rem 1rem;
          text-align: center;
          min-height: 10vh;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .header-title {
          font-family: "Montserrat", "Times New Roman", serif;
          font-size: 2rem;
          color: #000;
          letter-spacing: 1px;
        }

        /* --- MAIN LAYOUT --- */
        .main-content {
          display: flex;
          flex-direction: row;
          flex-grow: 1;
          min-height: 65vh;
        }

        @media (min-width: 768px) {
          .main-content {
            flex-direction: row;
            align-items: stretch;
          }
        }

        /* --- COLONNA SINISTRA --- */
        .left-column {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0rem;
        }

        .model-img {
          /*max-width: 100%;*/
          height: 600px;
          object-fit: contain;
        }

        /* --- COLONNA DESTRA --- */
        .right-column {
          flex: 1;
          display: flex;
          flex-direction: column;
          padding: 0.5rem;
          max-height: 65vh;
          overflow-y: hidden; 
          justify-content: center;
        }

        /* --- MODIFICHE FLEXBOX PER LA GRIGLIA --- */
        .variants-grid {
          display: flex;  
          flex-direction: row;        
          flex-wrap: wrap;        
          justify-content: center;
          gap: 0.3rem;              
          width: 100%;
          align-content: center;  
          padding: 1rem;
          max-height: 65vh;
          overflow-y: hidden;
        }
        .variants-grid-one-column {
          display: grid;  
          grid-template-columns: 1fr;
          flex-direction: row;        
          flex-wrap: wrap;        
          justify-content: center;
          gap: 0.3rem;              
          width: 100%;
          align-content: center;  
          padding: 0.3rem;
          max-height: 65vh;
          overflow-y: hidden;
        }
        /* ITEM PRODOTTO */
        .product-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }
        .product-item-with-sizes{
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: top;
        }
        /* 1 colonna (100% width) */
        .grid-single .product-item, .grid-single .product-item-with-sizes { 
          width: 100%; 
        }

        .grid-double .product-item,
        .grid-double .product-item-with-sizes{
          width: calc(100% - 0.7rem); 

        }


        /* 2 colonne (calc 50% - gap) */
        .grid-quad .product-item,
        .grid-quad .product-item-with-sizes { 
          width: calc(50% - 0.7rem); 
        }
        .grid-double {
          flex-direction: column;
        }
        /* 3 colonne (calc 33.33% - gap) */
        .grid-many .product-item, .grid-many .product-item-with-sizes{ 
          width: calc(33.333% - 1.34rem); 
        }

        .product-img {
          width: 100%;
          height: auto;
          min-height: 200px;
          max-height: 200px;
          object-fit: contain;
          margin-bottom: 5px; /* Ridotto leggermente per far spazio al prezzo */
        }

        /* --- STILE PREZZO --- */
        .product-price {
            font-family: "Montserrat", sans-serif;
            font-size: 1.1rem;
            font-weight: 500;
            color: #333;
            margin-bottom: 10px;
            text-align: center;
        }

        /* --- CONTROLLI QUANTITÀ --- */
        .qty-controls {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0;
          border: 1px solid #ddd;
          border-radius: 4px;
          overflow: hidden;
          background: #fff;
          width: 100px;
          height: 40px;
        }
          .qty-controls-min {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0;
          border: 1px solid #ddd;
          border-radius: 4px;
          overflow: hidden;
          background: #fff;
          width: 80px;
          height: 35px;
        }

        .qty-btn {
          background: #f9f9f9;
          border: none;
          width: 30px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: background 0.2s;
          color: #555;
        }

        .qty-btn:hover {
          background: #e0e0e0;
        }

        .qty-btn:active {
          background: #ccc;
        }

        .qty-input {
          width: 35px;
          height: 100%;
          border: none;
          border-left: 1px solid #ddd;
          border-right: 1px solid #ddd;
          text-align: center;
          font-size: 1.2rem;
          color: #333;
          -moz-appearance: textfield; 
        }
          .qty-input-min {
          width: 35px;
          height: 100%;
          border: none;
          border-left: 1px solid #ddd;
          border-right: 1px solid #ddd;
          text-align: center;
          font-size: 1rem;
          color: #333;
          -moz-appearance: textfield; 
        }
        
        .qty-input::-webkit-outer-spin-button,
        .qty-input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        .qty-input:focus {
          outline: none;
          background: #fefefe;
        }

        /* --- FOOTER --- */
        .footer {
          background-color: #FDF5A5; 
          padding: 0.5rem;
          text-align: center;
        }

        .footer-text {
          font-weight: 300;
          font-size: 0.9rem;
          color: #000;
          font-family: Montserrat, sans-serif;
        }

        /* --- DEBUG CONTROLS --- */
        .debug-controls {
          background: #eee;
          padding: 10px;
          text-align: center;
          font-size: 0.8rem;
          color: #666;
          border-top: 1px solid #ddd;
        }
        .btn { margin: 0 5px; padding: 5px 10px; cursor: pointer; }

        @media (min-width: 768px) {
            .header-title { font-size: 2.5rem; }
        }
      `}</style>

      <div className="app-container" style={{ marginLeft: isMobile ? (pagina.ord == 1 ? "150px" : "100px") : 0 }}>
        <header className="header">
          <p
            className="header-title"
            style={{
              fontFamily: "Poiret One, Times New Roman, serif",
              fontWeight: "600",
              fontSize: "1.2rem",
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
            }}
          >
            {pagina.showDescription ? description : null}
          </p>
        </header>
        {product && product.brands && product.brands.length > 0 ? <div style={{ alignSelf: "center", textAlign: "center", padding: "10px", marginTop: "6rem", position: "absolute", backgroundColor: "white", zIndex: 2, borderRadius: "8px", boxShadow: "0 0 10px rgba(0,0,0,0.1)" }}>

          <p style={{ color: "red", fontWeight: "500" }}>{product.brands}</p>

        </div> : null}
        <div className="main-content" style={{ backgroundImage: template === "mixed" || template === "photo_variant" || template === "single_variant" ? `url(${imageModel})` : "none", backgroundRepeat: "no-repeat", backgroundSize: "contain" }} >

          {(template === "mixed" ||
            template === "single_variant" || template === "photo_variant" ||
            template === "full_photo") && (
              <div
                className="left-column"
                style={
                  template === "single_variant" || template === "photo_variant" ? { flex: "3" } : { flex: "1" }
                }
              >
                {/*<img
                  src={imageModel}
                  alt="Modella con borsa"
                  className="model-img"
                />*/}
              </div>
            )}

          {template != "full_photo" && template != "grid_with_sizes" && (
            <div className="right-column">
              {variants.length === 0 ? (
                <p style={{ textAlign: "center", color: "#ccc" }}>
                  Nessuna variante
                </p>
              ) : (
                <div className={variants.length <= 2 && template != 'grid' ? `variants-grid-one-column ${getGridClass()}` : `variants-grid ${getGridClass()}`}>
                  {variants.map((v) => (
                    <div key={v.id} className="product-item">
                      {/* Immagine Prodotto */}

                      <ImageWithLoader
                        src={v.src}
                        alt={v.nomImg}
                        width={700}
                        height={500}
                        style={{
                          aspectRatio: "auto attr(width) / attr(height)",
                        }}
                        className="product-img img-fluid max-w-full h-auto mx-auto"
                        isSingleVariant={template === "single_variant" || template === "photo_variant"}
                      />

                      {/* --- PREZZO --- */}
                      <div className="product-price">
                        {v.priceSco ? <small><s>{formatPrice(v.price)}</s></small> : null}

                        {v.priceSco ? <b>{formatPrice(v.priceSco)}</b> : formatPrice(v.price)}
                      </div>

                      {/* Controlli Quantità */}
                      <div className="qty-controls"
                        onPointerDown={stopAllEvents}
                        onPointerUp={stopAllEvents}
                        onMouseDown={stopAllEvents}
                        onTouchStart={stopAllEvents}
                        onClick={stopAllEvents}
                        style={{ cursor: 'auto' }} // Forza il cursore normale per far capire che non è draggabile
                      >
                        <button
                          className="qty-btn"
                          onClick={(e) => {
                            stopAllEvents(e) // Blocca prima, 
                            updateQuantity(e, v.id, -1, v.pzMin, v.qtaConf, v.pzBox, v.preBox) // poi aggiorna
                          }}
                          onMouseMove={(e) => stopAllEvents(e)}
                          aria-label="Diminuisci quantità"
                        >
                          <Minus size={20} />
                        </button>

                        <input
                          type="number"
                          className="qty-input"

                          // USARE SOLO stopPropagation, MAI preventDefault SUGLI INPUT
                          onMouseDown={(e) => e.stopPropagation()}
                          onTouchStart={(e) => e.stopPropagation()}
                          onKeyDown={(e) => e.stopPropagation()} // Per poter usare le frecce tastiera
                          onClick={(e) => e.stopPropagation()}   // Per sicurezza

                          value={v.quantity}
                          onChange={(e) => handleInputChange(e, v.id, e.target.value)} // Nota: ho passato 'e' anche qui per sicurezza
                          min="0"
                          onDoubleClick={(e) => {
                            e.stopPropagation(); // Ferma eventi al libro
                            e.preventDefault();  // Evita selezioni strane

                            // Apri il dialog copiando i dati attuali
                            setEditDialog({
                              isOpen: true,
                              id: v.IDArtSizeColor, // (o v.id per la variante principale)
                              currentQty: v.quantity, // (o sizeItem.quantity)
                              min: v.pzMin || 0,
                              conf: v.qtaConf || 1,
                              pzBox: v.pzBox || 1,
                              preBox: v.preBox || "0.00"
                            });
                          }}
                        />

                        <button
                          className="qty-btn"
                          onClick={(e) => {
                            stopAllEvents(e)
                            updateQuantity(e, v.id, 1, v.pzMin, v.qtaConf, v.pzBox, v.preBox)
                          }}
                          onMouseMove={(e) => stopAllEvents(e)}
                          aria-label="Aumenta quantità"
                        >
                          <Plus size={20} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
          {template === "grid_with_sizes" && (
            <div className="right-column">
              {variants.length === 0 ? (
                <p style={{ textAlign: "center", color: "#ccc" }}>
                  Nessuna variante
                </p>
              ) : (
                <div className={`variants-grid ${getGridClass()}`}>
                  {variants.map((v) => (
                    <div key={v.id} className="product-item-with-sizes">
                      {/* Immagine Prodotto */}

                      <ImageWithLoader
                        src={v.sizes[0].src}
                        //alt={v.sizes[0].nomImg}
                        width={600}
                        height={300}
                        style={{
                          aspectRatio: "auto attr(width) / attr(height)",
                        }}
                        className="product-img img-fluid max-w-full mx-auto "
                        isSingleVariant={template === "single_variant" || template === "photo_variant"}
                      />
                      <div>
                        <span
                          style={{
                            fontSize: "12px",
                            display: "block",           // Necessario per applicare width/overflow
                            maxWidth: "100%",           // Occupa tutto lo spazio disponibile nel genitore
                            whiteSpace: "nowrap",       // Impedisce al testo di andare a capo
                            overflow: "hidden",         // Nasconde la parte eccedente
                            textOverflow: "ellipsis"    // Aggiunge i "..." finali
                          }}
                          title={v.color} // Opzionale: mostra il nome completo al passaggio del mouse
                        >
                          {v.color}
                        </span>
                        <table>
                          <tr>
                            <th style={{ fontSize: "12px" }}>Taglia</th>
                            <th style={{ fontSize: "12px" }}>Qta</th>
                          </tr>
                          {v.sizes.map((sizeItem) => (
                            <tr key={sizeItem.id}>
                              <td style={{ textAlign: "center", padding: "5px 10px" }}>
                                {sizeItem.sizeLabel}
                                {sizeItem.priceSco ? "*" : <>&nbsp;</>}
                              </td>
                              <td>
                                <div className="qty-controls-min"
                                  onPointerDown={stopAllEvents}
                                  onPointerUp={stopAllEvents}
                                  onMouseDown={stopAllEvents}
                                  onTouchStart={stopAllEvents}
                                  onClick={stopAllEvents}>
                                  <button
                                    className="qty-btn"
                                    onClick={(e) => {
                                      var qtaMin = sizeItem.pzMin || 1;
                                      var qtaConf = sizeItem.qtaConf || 1;
                                      updateQuantity(e, sizeItem.IDArtSizeColor, -1, qtaMin, qtaConf, sizeItem.pzBox, sizeItem.preBox)
                                    }
                                    }
                                    onMouseMove={(e) => stopAllEvents(e)}

                                    aria-label="Diminuisci quantità"
                                  >
                                    <Minus size={18} />
                                  </button>

                                  <input
                                    type="number"
                                    className="qty-input-min"

                                    // QUI C'ERA L'ERRORE: rimuovi stopAllEvents(e)
                                    onMouseDown={(e) => e.stopPropagation()}
                                    onTouchStart={(e) => e.stopPropagation()}
                                    onKeyDown={(e) => e.stopPropagation()}
                                    onClick={(e) => e.stopPropagation()}

                                    value={sizeItem.quantity}
                                    onChange={(e) =>
                                      handleInputChange(e, v.id, e.target.value) // Assicurati che handleInputChange accetti 'e' o toglilo se non serve lì
                                    }
                                    min="0"
                                    onDoubleClick={(e) => {
                                      e.stopPropagation(); // Ferma eventi al libro
                                      e.preventDefault();  // Evita selezioni strane

                                      // Apri il dialog copiando i dati attuali
                                      setEditDialog({
                                        isOpen: true,
                                        id: sizeItem.IDArtSizeColor, // (o v.id per la variante principale)
                                        currentQty: sizeItem.quantity, // (o sizeItem.quantity)
                                        min: sizeItem.pzMin || 0,
                                        conf: sizeItem.qtaConf || 1,
                                        pzBox: sizeItem.pzBox || 1,
                                        preBox: sizeItem.preBox || "0.00"
                                      });
                                    }}
                                  />

                                  <button
                                    className="qty-btn"
                                    onClick={(e) => { stopAllEvents(e); updateQuantity(e, sizeItem.IDArtSizeColor, 1, sizeItem.pzMin, sizeItem.qtaConf, sizeItem.pzBox, sizeItem.preBox) }}
                                    aria-label="Aumenta quantità"
                                    onMouseMove={(e) => stopAllEvents(e)}

                                  >
                                    <Plus size={18} />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </table>
                        <div className="product-price">
                          {trovaPrezzoScontato(variants, v.color) ? <small>{formatPrice(trovaPrezzo(variants, v.color))}</small> : formatPrice(trovaPrezzo(variants, v.color))}
                          {trovaPrezzoScontato(variants, v.color) && <b>&nbsp;*{formatPrice(trovaPrezzoScontato(variants, v.color))}</b>}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>)}
        </div>

        <footer className="footer">
          <p className="footer-text">
            {" "}
            {pagina.showDimensions ? measure || variantsMeasure : null}
          </p>
          <p>{ord}</p>
        </footer>

        <div className="debug-controls" style={{ display: "none" }}>
          <span>Controlli Simulazione: </span>
          <button
            onClick={removeVariant}
            className="btn"
            disabled={variants.length === 0}
          >
            - Rimuovi Variante
          </button>
          <span style={{ margin: "0 10px" }}>{variants.length} Varianti</span>
          <button onClick={addVariant} className="btn">
            + Aggiungi Variante
          </button>
        </div>
      </div>
    </>
  );
}
